import { RootState } from "../../../store";
import { billingAccountsSelector } from "../../../common/selectors/billing-accounts/billingAccountsSelector";

export const allAccountsLengthSelector = (state: RootState) => {
  return billingAccountsSelector(state)?.length;
};
